import React from "react";
import { statusClasses, statusLabel } from "../utils/expenseAdminFormat";

export default function ExpenseStatusBadge({ status }) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold ring-1 ${statusClasses(status)}`}
    >
      {statusLabel(status)}
    </span>
  );
}